import { render } from "./SaleSimple.vue?vue&type=template&id=4317bc14&scoped=true"
import script from "./SaleSimple.vue?vue&type=script&lang=js"
export * from "./SaleSimple.vue?vue&type=script&lang=js"

import "./SaleSimple.vue?vue&type=style&index=0&id=4317bc14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4317bc14"]])

export default __exports__